export const environment = {
  production: false,
  apiUrl: 'https://api.staging-01.pia.publicare-gmbh.de',
  templateBuilderUrl: 'https://tb.staging-01.pia.publicare-gmbh.de',
  auth: {
    clientId: '41dee0a7-87e9-4959-b38a-baaec4473177',
  },
};
